<template>
    <v-app>
        <v-theme-provider>
            <router-view transition="scroll-x-transition" class="body"></router-view>
        </v-theme-provider>
        <Toaster position="top-right" />
    </v-app>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Toaster } from "vue-sonner";

@Component({
    components: {
        Toaster,
    },
})
export class App extends Vue {
    showUpgradeUI = false;

    deferredPrompt = null;

    async accept() {
        this.showUpgradeUI = false;
    }

    showInstallPromotion() {
        this.showUpgradeUI = true;
    }

    async installApp() {
        this.showUpgradeUI = false;
        this.deferredPrompt.prompt();
        const { outcome } = await this.deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        this.deferredPrompt = null;
    }
}

export default toNative(App);
</script>
<style lang="scss"></style>
